const ROLES = {
    ADMIN: 'admin',
    COORDINATOR: 'coordinator',
    PARTICIPANT: 'participant',
};

export default ROLES;
